import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import simpleLoading from 'simple-loading';

Component('tr-header-team-menu', {
  mixins: [eventListenerMixin],

  properties: {},

  connected() {
    const links = this.querySelectorAll('.link-item a:not(#link-new-team)');
    Array.prototype.forEach.call(links, link => this.listenTo(link, 'click', (e) => {
      if (window.tower.metaKey(e)) return;
      simpleLoading({
        msg: '正在切换团队...',
        type: 'global',
      });
    }));
  },

  disconnected() {
    this.stopListening();
  },
});
